//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'Picker',
    props: ['status', 'index', 'values', 'keys'],
    data () {
        return {
            isShow: false,
            keyname: 'name',
            slots: [{
                flex: 1,
                values: [],
                className: 'slot1',
                textAlign: 'center',
                defaultIndex: 0
            }],
            changeLang: {}
        }
    },
    methods: {
        hidePirker () {
            this.$emit('hide', false)
        },
        selValueEven () {
            this.$emit('selValue', this.changeLang)
        },
        onValuesChange (v) {
            this.changeLang = v.getValues()[0]
        }
    },
    watch: {
        status (v) {
            this.isShow = v
        },
        values (v) {
            this.slots[0].values = v
        },
        index (v) {
            this.slots[0].defaultIndex = Number(v)
        }
    },
    created () {
        if (this.index) {
            this.slots[0].defaultIndex = Number(this.index)
        }
        if (this.values.length > 0) {
            this.slots[0].values = this.values
        }
        if (this.keys) {
            this.keyname = this.keys
        }
    }
}
